import React from 'react'
import * as DeviceDetect from 'react-device-detect'
import { ProxyLang } from '../Localization/locDef';
import { AppConfig } from '../configDef';
import { AppStateContext } from '../App';


//export const isHorizontalLayout = () => !DeviceDetect.isMobile // commentato perchè non è più statico


export function usePrevious<T>(value: T) {
  const ref = React.useRef<T>();
  React.useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  },[value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}


export type ProxyLoginResp = {
  access_token: string,
  session_id: string,
  user: {
    is_initial_user_login: boolean,
  }
}

export const requestProxyLogin = async (username: string, password: string, vampUrl: string): Promise<ProxyLoginResp> => {
  
  const settings: RequestInit = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "username": username,
        "password": password,
      }),
  }
  try {
      // console.log("sending login request:")
      // console.log(settings)
      const fetchResponse = await fetch(vampUrl + "/login", settings);
      // console.log("received response:")
      // console.log(fetchResponse)
      const json = await fetchResponse.json();
      // json.user.is_initial_user_login = true;
      // console.log(json)
      if (
        'access_token' in json && typeof json.access_token === 'string' &&
        'session_id' in json && typeof json.session_id === 'string'
      ) {
        return json
      } else {
        throw new Error('json content not as expected')
      }
  } catch (e) {
      console.log("reqVampAccessToken error: " + JSON.stringify(e))
      throw new Error()
  }    
}

export const requestPasswordReset = async (username: string, password: string, newPassword: string, vampUrl: string): Promise<JSON> => {
  const settings: RequestInit = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "email": username,
        "password": password,
        "newpassword": newPassword,
      }),
  }
  try {
      const fetchResponse = await fetch(vampUrl + "/changePassword", settings);
      return fetchResponse.json() 
  } catch (e) {
      console.log("reqVampAccessToken error: " + JSON.stringify(e))
      throw new Error()
  }    
}

type RequestFunction = 'lessons_completion_percentage' | 'resume-tutorai' | 'resume' | 'next_paragraph' | 'question'
type ProxyMessageReq = {
    "sessionID": string,
    "user_id": string,
    "generator": 'Tellme' | 'Chatbot',
    "question": string,
    "message": {
    "text": string,
    },
    "variables": {
        "tts": string,
        "customer_area": 'Edu' | 'Customer care',
    }
    "request_details"?: {
      "function": RequestFunction,
      "course"?: string,
      "lesson"?: string,
    }
}

export type ProxyMessageResp = {
    message: {
        multiple_questions?: object,
        question?: string,
        question_gpt3?: string,
        text?: string,
        tts?: string,
        media?: {
          IMAGE?: string,
        }
    },
    variables: {
        customer_area?: string,
        language?: string,
        ref?: string,
        tts?: string,
    },
    request_details: {
      course?: string,
      course_percentage?: number,
      lesson?: string,
      paragraph?: string | {[k: string]: string},
      paragraph_media?: string | {[k: string]: string},
    }
    lessons_completion_percentage?: any,
    assessments?: {[course: string]: string[] | {[lesson: string]: {assessment: number}}},
}

export type ProxyMessageData = {
  function: RequestFunction,
  course: string | undefined,
  lesson: string | undefined,
  messageText: string,
}

const removeUndefineds = (obj: any) => {
  let newObj: any = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === Object(obj[key])) newObj[key] = removeUndefineds(obj[key]);
    else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
}

export const sendMessageToProxy = async (
  proxyUrl: string,
  username: string,
  sessionId: string,
  language: ProxyLang,
  token: string,
  messageData: ProxyMessageData,
) => {
  const requestWithUndefineds: ProxyMessageReq = {
    sessionID: "sessionId",
    user_id: username,
    generator: 'Chatbot',
    question: messageData.messageText,
    message: {
      text: messageData.messageText,
    },
    variables: {
      tts: '',
      customer_area: 'Customer care',
    }
  }
  const request = removeUndefineds(requestWithUndefineds)
  const settings: RequestInit = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
    },
    body: JSON.stringify(removeUndefineds(request))
  }
  console.log("request body:", removeUndefineds(request))
  let fetchResponse
  try {
      fetchResponse = await fetch(proxyUrl + "/engine/" + language, settings);
      console.log("received engine response:", JSON.stringify(fetchResponse))
  } catch (e) {
      console.log("sendMessageToProxy error: " + JSON.stringify(e))
      throw e
  }
  const json = await fetchResponse.json();
  if (typeof json === 'object' && 'message' in json) {
    return json as ProxyMessageResp
  } else {
    throw new Error()
  }
}

export const decodeProxyMessageResponse = (resp: ProxyMessageResp) => {
  const question = resp.message.question_gpt3 || resp.message.question
  // readableText è una lista, perchè in kolinpharma possono arrivare più paragrafi insieme
  const readableText: string[] =
    (resp.message.text ?? '') !== ''
      ? [resp.message.text ?? '']
      : typeof resp.request_details.paragraph === 'string'
        ? [resp.request_details.paragraph]
        : typeof resp.request_details.paragraph === 'object' && resp.request_details.paragraph !== null
          ? Object.entries(resp.request_details.paragraph).toSorted((a, b) => a[0].localeCompare(b[0])).map(e => e[1])
          : ['']
  const ttsText = (resp.message.tts ?? '').replace('<speak>', '').replace('<break time=\"2s\"/></speak>', '') // rimuove roba che hanno lasciato da Polly di Amazon

  // per adesso choices disattivate
  const choices = null
  /*const choicesDoc = doc.getElementsByTagName('multiple_questions')?.[0]
  let choices: string[] | null
  if (!choicesDoc) {
    choices = null
  } else {
    choices = [
      choicesDoc.getElementsByTagName('question_1')?.[0]?.innerHTML,
      choicesDoc.getElementsByTagName('question_2')?.[0]?.innerHTML,
      choicesDoc.getElementsByTagName('question_3')?.[0]?.innerHTML,
      choicesDoc.getElementsByTagName('question_4')?.[0]?.innerHTML,
    ].filter(s => s ?? false)
  }*/

  const ref = resp.variables.ref

  // per adesso sinonimi disattivati
  const synonyms = null
  /*const synonyms = [
    variablesDoc?.getElementsByTagName('syn_topic')?.[0]?.innerHTML,
    variablesDoc?.getElementsByTagName('syn_action1')?.[0]?.innerHTML,
    variablesDoc?.getElementsByTagName('syn_action2')?.[0]?.innerHTML,
    variablesDoc?.getElementsByTagName('syn_subtopic')?.[0]?.innerHTML,
  ] as (string | undefined)[]*/

  const images: string[] = (resp.message.text ?? '') !== '' && resp.message.media?.IMAGE
    ? [resp.message.media.IMAGE] // Add image from message.media.img when message.text exists
    : resp.request_details && typeof resp.request_details.paragraph === 'object' && resp.request_details.paragraph !== null
    ? Object.keys(resp.request_details.paragraph).toSorted((a, b) => a.localeCompare(b)).map(key => {
        const mediaObj = resp.request_details.paragraph_media;
        if (typeof mediaObj === 'object' && mediaObj !== null && key in mediaObj) {
          return mediaObj[key];
        }
        return '';
      })
    : resp.request_details && typeof resp.request_details.paragraph_media === 'string'
      ? [resp.request_details.paragraph_media]
      : ['']
      //const image = 'https://media.istockphoto.com/id/1316134499/it/foto/immagine-concettuale-di-una-lente-dingrandimento-su-sfondo-blu-con-una-parola-example-zoom.webp?s=2048x2048&w=is&k=20&c=GgC-7dUpcWOvAa1_lqx2t9yxHwzP971U5cz1KYWTElw='
  //const image = variablesDoc?.getElementsByTagName('image')?.[0]?.innerHTML ?? ''

  // emozioni, che adesso non ci sono
  /*const exmlDoc = doc.getElementsByTagName('exml')?.[0]
  const emotions = {
    joy: Number(exmlDoc.getElementsByTagName('joy')?.[0]?.innerHTML ?? '0'),
    anticipation: Number(exmlDoc.getElementsByTagName('anticipation')?.[0]?.innerHTML ?? '0'),
    anger: Number(exmlDoc.getElementsByTagName('anger')?.[0]?.innerHTML ?? '0'),
    disgust: Number(exmlDoc.getElementsByTagName('disgust')?.[0]?.innerHTML ?? '0'),
    sadness: Number(exmlDoc.getElementsByTagName('sadness')?.[0]?.innerHTML ?? '0'),
    surprise: Number(exmlDoc.getElementsByTagName('surprise')?.[0]?.innerHTML ?? '0'),
    fear: Number(exmlDoc.getElementsByTagName('fear')?.[0]?.innerHTML ?? '0'),
    trust: Number(exmlDoc.getElementsByTagName('trust')?.[0]?.innerHTML ?? '0'),
  }*/

  return {
    question: question,
    readableText: readableText,
    ttsText: /*ttsText*/ttsText ?? '', // in tutor-ai non arriva testo apposta per il tts, e serve solo l'ultimo testo in caso ce ne sia più di uno
    choices: choices,
    ref: ref,
    synonyms: synonyms,
    image: images,
    lesson: resp?.request_details?.lesson,
    lessonPercentage: resp?.request_details?.course_percentage,
  }
}
export type DecodedProxyMessageResp = NonNullable<ReturnType<typeof decodeProxyMessageResponse>>
/*type Emotion = keyof DecodedVampResp['emotions']
type EmotionOrNull = Emotion | null*/